import { CartographyInfosResourcePosition } from './cartography-infos-resource-position';

export class CartographyResourceInfosPositionBbx extends CartographyInfosResourcePosition {
  public kilometers: number;
  public speed: number;
  public materials: unknown[];
  public cap: number;
}
